/* eslint-disable no-loop-func */
import React from 'react';
import DialogBox from '../../components/DialogBox';
import DrawerPwa from '../../components/DrawerPwa';
import PHBackButton from '../../components/PHBackButton';
import partyPoppers from './images/bg.png';
import ribbon from './images/ribbon.png';
import enabledCartBag from './images/cartBag.svg';
import disabledCartBag from './images/disabledCartBag.svg';
import css from './index.module.scss';
import { Redux, Slices } from 'spwa-ui-library';
import { useIntl, FormattedMessage } from 'react-intl';
import { useLocation } from '@reach/router';
import {
  getAddedItems,
  getRemovedItems,
  getVariantDetails,
  decimalChecker,
} from 'spwa-ui-library/esm/utils/helper';
import noImg from '../../assets/no-itm.png';
import classNames from 'classnames';

const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectCurrentCountry } = Slices.profileSlice;

const { selectCountryValidations, getDecimalPoints } = Slices.configSlice;

function BogoFreePizzaUnlocked({ productId, isAddToCartEnabled, addtoCart, setEnableBogoPopup }) {
  const intl = useIntl();
  const location = useLocation();

  const locationSearch = new URLSearchParams(location.search);

  const productsMap = useSelector(selectProductEntities);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const tempCart = useSelector((state) => state.tempCart);
  const decimalPoints = useSelector(getDecimalPoints);
  const isDesktop = useSelector(selectDesktop);

  const items = [];
  const productCustomization = tempCart.data.items.find((item) => item.id == productId);

  for (let stepObj of Object.values(productCustomization?.bundle || {})) {
    let step = JSON.parse(JSON.stringify(stepObj));
    for (let [stepId, stepData] of Object.entries(stepObj || {})) {
      if (stepData?.notAdded) {
        delete step[stepId];
      }
    }
    const itemId = Object.keys(step)[0];
    const itemCustomization = Object.values(step)[0];

    const optionId = parseInt(locationSearch.get('option'));
    let productObj = productsMap[productId]?.items
      ?.find((item) => item?.id == optionId)
      ?.steps?.[0]?.options?.find((option) => option?.id == itemId);

    if (!productObj) {
      productObj = bogoProducts[optionId]?.find((option) => option?.id == itemId);
    }

    let itemInfo;
    let selectedItemIndex = -1;

    if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
      selectedItemIndex = 0;
    } else {
      let variationArray = [-1, -1, -1];

      if (Object.values(itemCustomization?.variants || {}).length > 0) {
        Object.values(itemCustomization?.variants || {}).forEach((variant, index) => {
          variationArray[index] = variant;
        });
      } else {
        Object.values(productObj?.variants || {}).forEach((variant, index) => {
          const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
          if (selectedOption) {
            variationArray[index] = selectedOption?.id;
          }
        });
      }

      productObj.items.forEach((item, i) => {
        let areVariationsSame = true;
        variationArray.forEach((value, index) => {
          if (item[`sel${index + 1}Value`] != value) {
            areVariationsSame = false;
          }
        });

        if (areVariationsSame) {
          selectedItemIndex = i;
        }
      });
    }

    itemInfo = productObj?.items?.[selectedItemIndex];
    if (!itemInfo?.steps?.options) {
      itemInfo =
        productsMap[productObj?.id]?.items?.find((item) => item?.id == itemInfo?.id) ||
        productObj?.items[selectedItemIndex] ||
        itemInfo;
    }
    if (!itemInfo?.id) {
      itemInfo = productsMap[itemInfo];
    }

    let basePrice = 0;
    basePrice +=
      itemInfo?.price >= 0
        ? itemInfo?.price
        : itemInfo?.specialPrice || itemInfo?.originalPrice || 0;

    let extraPrice = 0;

    for (let step of itemInfo?.steps || []) {
      for (let option of step?.options || []) {
        if (option?.subOptions) {
          extraPrice +=
            option?.subOptions[itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] - 1]
              ?.price || 0;
        } else {
          if (itemCustomization?.items?.[step.id]?.[option.id]?.['qty']) {
            extraPrice +=
              (option?.price || 0) *
              Number(itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] || 0);
          }
        }
      }
    }

    const addedItems = getAddedItems(itemCustomization, itemInfo);
    const removedtems = getRemovedItems(itemCustomization, itemInfo);

    items.push({
      name: productObj?.name || productObj?.title,
      img: productObj?.assets[0]?.src,
      variantText: getVariantDetails(itemCustomization, productObj),
      basePrice: basePrice || 0,
      extraPrice: extraPrice || 0,
      addedItems: addedItems,
      removedtems: removedtems,
    });
  }

  if ((items[0]?.basePrice || 0) == (items[1]?.basePrice || 0)) {
    items.sort(
      (item1, item2) => ((item2.basePrice + item2.extraPrice) - (item1.basePrice + item1.extraPrice)));
  } else {
    items.sort((item1, item2) => item2.basePrice - item1.basePrice);
  }

  let totalPrice = items[0].basePrice || 0;
  for (let item of items) {
    totalPrice += (item.extraPrice || 0);
  }

  const AddToCartButton = () => (
    <div
      className={classNames(css.checkoutSection, { [css.disabledButton]: !isAddToCartEnabled })}
      onClick={addtoCart}
    >
      <div className={css.cartAmount}>
        {isAddToCartEnabled && (
          <div className={css.cartImg}>
            <img
              src={productsMap[productId].assets[0].src}
              alt=""
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImg;
              }}
            />
          </div>
        )}
        <div className={css.itemDetail}>
          {isAddToCartEnabled && <h4>1 ITEM</h4>}
          <h5>
            <span>{decimalChecker(totalPrice, decimalPoints)}</span>
            <span>{countryValidations.currency}</span>
            {isAddToCartEnabled && (
              <span className={css.taxInclusiv}>
                {intl.formatMessage({ id: 'inclusive_of_taxes' })}
              </span>
            )}
          </h5>
        </div>
      </div>
      <div className={css.checkoutButton}>
        <img src={isAddToCartEnabled ? enabledCartBag : disabledCartBag} alt="Cart bag" />
        <span className={css.label}>
          {locationSearch.has('cartId') ? (
            <FormattedMessage id="update_cart" defaultMessage="Update Cart" />
          ) : (
            <FormattedMessage id="product_addtocart" defaultMessage="Add to cart" />
          )}
        </span>
      </div>
    </div>
  );

  const renderContent = () => (
    <div className={css.contentRoot}>
      <div className={css.backButton}>
        <PHBackButton
          onclick={() => {
            window.localStorage.setItem('notShowBogoPopup', true);
            setEnableBogoPopup(false);
          }}
          cross={true}
        />
      </div>
      <img className={css.partyPoppers} src={partyPoppers} alt="party poppers" />
      <div className={css.contentTitle}>
        <span className={css.woohoo}>{intl.formatMessage({ id: 'woohoo' })}</span>
        <p className={css.subtitle}>
          <span>{intl.formatMessage({ id: 'you_have_unlocked_a' })}</span>
          <span>{intl.formatMessage({ id: 'free_pizza' })}</span>
        </p>
      </div>

      <hr className={css.dashedLine} />

      <div className={css.itemList}>
        {items.map((item, index) => (
          <div className={css.itemInfo}>
            <div className={css.itemDetails}>
              <div className={css.imageContainer}>
                <img
                  className={css.itemImg}
                  src={item.img}
                  alt={`${item.title}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImg;
                  }}
                />
                {(index == (items.length - 1)) && (
                  <>
                    <img
                      className={css.ribbonImg}
                      src={ribbon}
                      alt="ribbon"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImg;
                      }}
                    />
                    <span className={css.ribbonText}>
                      {intl.formatMessage({ id: 'free_pizza_no_icon' })}
                    </span>
                  </>
                )}
              </div>
              <div className={css.item}>
                <p className={css.itemTitle}>{item.name}</p>
                <p className={css.itemVariant}>{item.variantText}</p>
                {item?.addedItems && (
                  <p className={css.addedItems}>
                    <span className={css.greenText}>
                      {`${intl.formatMessage({
                        id: 'added',
                      })} : `}
                    </span>{' '}
                    {item.addedItems}
                  </p>
                )}
                {item?.removedtems && (
                  <p className={css.addedItems}>
                    <span className={css.redText}>
                      {`${intl.formatMessage({
                        id: 'removed',
                      })} : `}
                    </span>{' '}
                    {item.removedtems}
                  </p>
                )}
                {item?.extraPrice > 0 && (
                  <p className={css.extraPrice}>
                    {`${intl.formatMessage({ id: 'you_need_to_pay_extra' })} : `}
                    <span>
                      {decimalChecker(item.extraPrice, decimalPoints)}
                      {` `}
                      {countryValidations.currency}
                    </span>
                  </p>
                )}
                {index == items.length - 1 && (
                  <p className={css.madeFree}>
                    <span>{intl.formatMessage({ id: 'lower_price_pizza_made_free' })}</span>
                  </p>
                )}
              </div>
            </div>
            <div
              className={classNames(css.itemPrice, { [css.strikeThru]: index == (items.length - 1) })}
            >
              {`${decimalChecker(item.basePrice, decimalPoints)} ${countryValidations.currency}`}
            </div>
          </div>
        ))}
      </div>

      <AddToCartButton />
    </div>
  );

  return (
    <>
      {isDesktop ? (
        <DialogBox
          size="md"
          className={css.unlockedFreePizzaRoot}
          hideCloseButton={true}
          isOpen={true}
          onClose={() => {}}
        >
          {renderContent()}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          className={css.unlockedFreePizzaRoot}
          open={true}
          extraClass={css.bundleSelector}
          onClose={() => {}}
          hideCloseButton={true}
        >
          {renderContent()}
        </DrawerPwa>
      )}
    </>
  );
}

export default BogoFreePizzaUnlocked;
